import {useEEToolAdapterContext} from "../contexts/eeToolAdapterContext";
import {KeyboardEvent, KeyboardEventHandler, useEffect, useRef} from "react";

export function PointTextControl() {
    const context = useEEToolAdapterContext()
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (context.isPointTextVisible) {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }
    }, [context.isPointTextVisible]);

    const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            context.pointTextFn((event.target as HTMLInputElement).value);
            context.hidePointText();
        }
    };

    if (!context.isPointTextVisible)
        return <></>;

    return (
        <input style={{
            display: 'inline',
            position: 'absolute',
            width: '46px',
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '-0.3px',
            lineHeight: '8px',
            left: context.pointTextLeft,
            top: context.pointTextTop
        }}
               value={context.pointTextValue}
               ref={inputRef}
               onKeyDown={handleKeyPress}
               onChange={(e) => context.setPointTextValue(e.target.value)}
        />
    );
}
